import { useCustomQuery } from "../custom-query";
import { useCustomMutation } from "../custom-mutation";
import { get, post, put, del } from "../request-helpers";
import {
  GetCustomerNoteTags,
  PostCustomerNoteTag,
  PutCustomerNoteTag,
  DeleteCustomerNoteTag,
  GetCustomerNoteTag,
} from "@/server-types";
import { queryClient } from "..";

export const useGetCustomerNoteTags = (props: { disabled?: boolean }) => {
  return useCustomQuery({
    queryKey: ["useGetCustomerNoteTags", props],
    queryFn: () => get<GetCustomerNoteTags>(`/customer-note/tag`),
    enabled: !props.disabled,
  });
};

export const usePostCustomerNoteTag = () => {
  return useCustomMutation({
    mutationFn: (props: { body: PostCustomerNoteTag["body"] }) =>
      post<PostCustomerNoteTag>(`/customer-note/tag`, props.body),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["useGetCustomerNoteTags"],
      });
    },
  });
};

export const usePutCustomerNoteTag = () => {
  return useCustomMutation({
    mutationFn: (props: {
      params: PutCustomerNoteTag["params"];
      body: PutCustomerNoteTag["body"];
    }) =>
      put<PutCustomerNoteTag>(
        `/customer-note/tag/${props.params.tagId}`,
        props.body,
      ),
    onSuccess: (_, props) => {
      queryClient.invalidateQueries({
        queryKey: ["useGetCustomerNoteTags"],
      });

      queryClient.invalidateQueries({
        queryKey: ["useGetCustomerNoteTag", props.params.tagId],
      });
    },
  });
};

export const useDeleteCustomerNoteTag = () => {
  return useCustomMutation({
    mutationFn: (props: { params: DeleteCustomerNoteTag["params"] }) =>
      del<DeleteCustomerNoteTag>(`/customer-note/tag/${props.params.tagId}`),
    onSuccess: (_, props) => {
      queryClient.invalidateQueries({
        queryKey: ["useGetCustomerNoteTags"],
      });

      queryClient.invalidateQueries({
        queryKey: ["useGetCustomerNoteTag", props.params.tagId],
      });
    },
  });
};

export const useGetCustomerNoteTag = (props: {
  params: GetCustomerNoteTag["params"];
  disabled?: boolean;
}) => {
  return useCustomQuery({
    queryKey: ["useGetCustomerNoteTag", props.params.tagId],
    queryFn: () =>
      get<GetCustomerNoteTag>(`/customer-note/tag/${props.params.tagId}`),
    enabled: !props.disabled,
  });
};
